/* global Promise modForm */
export default async function lazyLoadScripts(config = {}, customLazyScripts = []) {
	const _this = this;

	if (typeof config !== 'object') {
		return false;
	}

	let isProgressBarScriptLoaded = false;

	const lazyLoadConfig = {
		homeowner: {
			onloadCallBack: function() {
				window.homeOwnerScriptLoaded = true;
				_this.initModForm();
				_this.stepCount = window.modForm.opts.steps.length;

				const $form = _this?.$form || document.querySelector('form');
				const $formButton = $form?.querySelector('.btn--primary');
				$formButton?.removeAttribute('type');
				$form?.classList.remove('form--loading');

				if (window.interactedWithFormElement) {
					$formButton?.click();
				}

				if (modForm && typeof modForm.initExtraQuestionBlock === 'function' && window.clickedRadioButton) {
					modForm.initExtraQuestionBlock(window.clickedRadioButton);
				}

				if (isProgressBarScriptLoaded && typeof _this.params.startStep !== 'undefined') {
					// extract step number from startStep param
					const stepNumber = parseInt(_this.params.startStep.match(/step(\d+)/)?.[1], 10);
					if (stepNumber && typeof window.updateProgressBar === 'function') {
						window.updateProgressBar(stepNumber);
					}
				}

				if (window.Footer) {
					window.Footer.init();
				}
			}
		},
		carousel: {
			onloadCallBack: function() {
				_this.formSwiperInstance = window.modCarousel.init('#swiperForm', {
					speed: 500,
					preventInteractionOnTransition: true,
					a11y: {
						slideLabelMessage: '',
						containerRoleDescriptionMessage: 'carousel',
						slideRole: ''
					}
				});

				const carouselLoadEvent = new CustomEvent('carousel.loaded');
				document.dispatchEvent(carouselLoadEvent);
			}
		},
		'progress-bar': {
			onloadCallBack: function() {
				isProgressBarScriptLoaded = true;
			}
		}
	};

	Object.assign(lazyLoadConfig, config);

	if (!lazyLoadConfig || !Object.keys(lazyLoadConfig).length) {
		return false;
	}

	let lazyScripts = customLazyScripts;
	if (!lazyScripts || !lazyScripts.length) {
		lazyScripts = document.querySelectorAll('script[data-src]');
	}

	let loadedScriptCount = 0;

	// reusable error handler for script loading failures
	const handleScriptError = (scriptUrl, error) => {
		window.Modalytics.heap('track', ['Failed to Swap Script Source', {
			scriptUrl: scriptUrl,
			errorMessage: error
		}]);
	};

	const load = async function(entry) {
		const dataDependencies = entry?.dataset?.dependencies?.split(',');
		if (dataDependencies && dataDependencies.length) {
			for (const dependency of dataDependencies) {
				const dependencyScript = document.querySelector(`script[data-key=${dependency}]`);
				if (dependencyScript) {
					await load(dependencyScript);
				}
			}
		}

		await new Promise((resolve, reject) => {
			if (entry?.dataset?.src) {
				entry.src = entry.dataset.src;
			}
			entry.onerror = function(error) {
				if (window.heap) {
					handleScriptError(entry.src, error);
				} else {
					document.addEventListener('heap.loaded', function() {
						handleScriptError(entry.src, error);
					});
				}
				reject();
			};
			entry.onload = function() {
				const dataKey = entry?.dataset?.key;
				if (lazyLoadConfig[dataKey] && typeof lazyLoadConfig[dataKey].onloadCallBack === 'function') {
					lazyLoadConfig[dataKey].onloadCallBack();
				}
				entry.removeAttribute('data-src');
				entry.removeAttribute('data-dependencies');
				entry.removeAttribute('data-key');

				if (loadedScriptCount === lazyScripts.length - 1) {
					const eventName = customLazyScripts && customLazyScripts.length ? 'custom.lazyScript.load.done' : 'lazyScript.load.done';
					const scriptLoadDoneEvent = new CustomEvent(eventName);
					document.dispatchEvent(scriptLoadDoneEvent);
				}

				loadedScriptCount++;
				resolve();
			};
		});
	};

	if (lazyScripts && lazyScripts.length) {
		for (const lazyScript of lazyScripts) {
			await load(lazyScript);
		}
	}
}

document.addEventListener('DOMContentLoaded', function() {
	const hash = window.location.hash.replace('#', '');
	if (hash) {
		const $hashMatchingStep = document.querySelector(`[data-step-name=${hash}]`);
		if ($hashMatchingStep) {
			window.history.replaceState({}, document.title, window.location.href.split('#')[0]);
		}
	}
}, { once: true });

window.addEventListener('load', function() {
	const $zip = document.querySelector('input[name="zip"]');
	const params = window.modUtils.getUrlParamsToObject();

	if (typeof params.zip !== 'undefined' && $zip) {
		$zip.value = params.zip;
	}
}, {
	passive: true,
	capture: true,
	once: true
});
